import { Component, OnInit, Input } from '@angular/core';
import * as Chart from 'chart.js';
import * as numeral from 'numeral';

@Component({
  selector: 'chart-ventasnetasxanio',
  templateUrl: './ventasnetasxanio.component.html',
  styleUrls: ['./ventasnetasxanio.component.css']
})
export class VentasnetasxanioComponent implements OnInit {
    @Input() periodo: String;
    @Input() fecha_inicio;
    @Input() fecha_fin;
    public compra: number;
    public venta: number;
    public loading: boolean;
    private myChart: any;
  constructor(

  ) {

    this.compra = 0;
        this.venta = 0;
        this.loading = false;
   }

  ngOnInit() {
    this.initChart();
}

initChart(periodo?) {
    this.periodo = periodo ? periodo : this.periodo;

    this.compra = 0;
    this.venta = 0;

    this.loading = true;
    this.getData().then(
        res => {
            this.drawChart();
            this.loading = false;
        },
        err => {
            this.loading = false;
        }
    );
}

getData() {
    return new Promise((resolve, reject) => {
        let qs = "";
        if(this.periodo == "otro"){
            qs = "?periodo=" + this.periodo + "&fecha_inicio=" + this.fecha_inicio + "&fecha_fin=" + this.fecha_fin;
        }else{
            qs = "?periodo=" + this.periodo;
        }

        // this.desktopService.getComprasVsVentas(qs).subscribe(
        //     res => {
        //         this.compra = res.compra ? res.compra : 0;
        //         this.venta = res.venta ? res.venta : 0;
        //         resolve();
        //     },
        //     err => {
        //         this.compra = 0;
        //         this.venta = 0;
        //         reject(err);
        //     }
        // );

    });

}

updateDataChart(periodo, fecha_inicio, fecha_fin) {
    this.periodo = periodo ? periodo : this.periodo;
    this.fecha_inicio = fecha_inicio ? fecha_inicio : this.fecha_inicio;
    this.fecha_fin = fecha_fin ? fecha_fin : this.fecha_fin;
    this.compra = 0;
    this.venta = 0;

    this.loading = true;
    this.getData().then(
        res => {
            this.myChart.data.datasets[0].data = [parseFloat(this.compra.toString()).toFixed(2)];
            this.myChart.data.datasets[1].data = [parseFloat(this.venta.toString()).toFixed(2)];
            this.myChart.update();

            this.loading = false;
        },
        err => {
            this.loading = false;
        }
    );
}

drawChart() {
    var ctx = document.getElementById("csvVentasNetasXAnio");
    //let dataSetValue1 = numeral(this.compra.toString()).format('0,0.00');
    //let dataSetValue2 = numeral(this.venta.toString()).format('0,0.00');
    this.myChart = new Chart(ctx, {
        type: 'bar',
        data: {
            datasets: [{
                label: 'ENERO',
                data: [parseFloat(this.compra.toString()).toFixed(2)],
                backgroundColor: ['rgba(54, 162, 235, 0.2)',],
                borderColor: ['rgba(54, 162, 235, 1)',],
                borderWidth: 1
            }, {
                label: 'VENTAS',
                data: [parseFloat(this.venta.toString()).toFixed(2)],
                backgroundColor: ['rgba(153, 102, 255, 0.2)',],
                borderColor: ['rgba(153, 102, 255, 1)',],
                borderWidth: 1
            },{
                label: 'VENTAS',
                data: [parseFloat(this.venta.toString()).toFixed(2)],
                backgroundColor: ['rgba(153, 102, 255, 0.2)',],
                borderColor: ['rgba(153, 102, 255, 1)',],
                borderWidth: 1
            
            }]
        },
        options: {
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true
                    }
                }]
            },
            tooltips: {
                enabled: true,
                mode: 'single',
                callbacks: {
                    //title: function (tooltipItem, data) {
                    //    return "Día " + data.labels[tooltipItem[0].index]; 
                    //},
                    label: function(tooltipItems, data) {
                        return "$ " + numeral(tooltipItems.yLabel).format('0,0.00');
                    },
                    //footer: function (tooltipItem, data) { return "..."; }
                }
            },
        }
    });
}

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/charts/ventasnetasxanio/ventasnetasxanio.component.ts